import http from './_http';
import { logWebHrError } from "@/core/logger/log-wrapper";

export async function docSignatureFileGet({
  onboardingId,
  documentId,
  fieldId,
}) {
  try {
    const requiredFields = ['onboardingId', 'documentId', 'fieldId'];
    requiredFields.forEach(field => {
      // eslint-disable-next-line prefer-rest-params
      if (!arguments[0][field]) {
        throw new Error(`${field} is required`);
      }
    });

    const res = await http.get(
      `/onboarding/${onboardingId}/docsignatures/${documentId}/fields/${fieldId}/files`,
      {
        headers: {
          'Content-Type': 'application/pdf',
        },
        responseType: 'blob',
        data: {},
      }
    );
    return res;
  } catch (e) {
    logWebHrError({
      message: 'Failed to get document signature file',
      source: 'docsignature-file-get',
      metadata: {
        onboardingId,
        documentId,
        fieldId,
      },
      error: e,
    });
    throw e;
  }
}

export default {
  docSignatureFileGet,
};
